import { Country, LearningObjectiveType } from '@types';

export const initialValues = {
    title: '',
    objective_type: null,
    year_id: null,
    concept: '',
    practice: '',
    application: '',
    learning_contents: [],
    standard_codes: [],
    ai: true,
};

export const countryInitialValues: Record<Country, any> = {
    [Country.GB]: {
        ...initialValues,
        country: Country.GB,
        objective_type: LearningObjectiveType.STANDARD,
    },
    [Country.US]: {
        ...initialValues,
        country: Country.US,
    },
};
